import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import { resources } from './translations';

export const LANGUAGE_STORAGE_KEY = 'constadmin.language';
export const SUPPORTED_LANGUAGES = ['en', 'hr'];

const getInitialLanguage = () => {
  const storedLanguage = localStorage.getItem(LANGUAGE_STORAGE_KEY);
  if (storedLanguage && SUPPORTED_LANGUAGES.includes(storedLanguage)) {
    return storedLanguage;
  }
  return 'en';
};

i18n.use(initReactI18next).init({
  resources,
  lng: getInitialLanguage(),
  fallbackLng: 'en',
  interpolation: {
    escapeValue: false,
  },
});

i18n.on('languageChanged', (language) => {
  localStorage.setItem(LANGUAGE_STORAGE_KEY, language);
  document.documentElement.lang = language;
});

document.documentElement.lang = i18n.language || 'en';

export default i18n;
